import { render } from "./new.html?vue&type=template&id=6bc8b3bd&ts=true&external"
import script from "./new.ts?vue&type=script&lang=ts&external"
export * from "./new.ts?vue&type=script&lang=ts&external"

import "./new.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__